import en from "./en.translation.json";
import es from "./es.translation.json";
import {
    BLOCKED,
    COMPLETE,
    NOT_STARTED,
    PENDING,
} from "../../../paperwork/constants";
import neededPaperworkTemplate from "./needed_paperwork.html";
import { growerPaperworkState } from "../../../../base.routes";

class NeededPaperworkController {
    /* @ngInject */
    constructor($state) {
        this.PENDING = PENDING;
        this.NOT_STARTED = NOT_STARTED;
        this.BLOCKED = BLOCKED;
        this.COMPLETE = COMPLETE;
        this.$state = $state;
    }

    goToPaperwork(grower) {
        let ctrl = this;
        ctrl.showSpinner = true;
        ctrl.$state.go(growerPaperworkState, { grower_sid: grower.sid });
    }
}

export default {
    bindings: { myPaperwork: "<", documentPackages: "<", growers: "<" },
    controller: NeededPaperworkController,
    template: neededPaperworkTemplate,
    name: "neededPaperwork",
    translations: { en, es },
};
